import { render } from "./Delete.svg?vue&type=template&id=4e328f32"
const script = {}

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__